import React, { useState, useEffect } from 'react';
import { LoadingIcon } from '@prosolve/common-components-ui'
import useFetch from '../../../hooks/useFetch';
import styled from 'styled-components';

const Item = styled.div`
  background: ${props => props.$selected ? '#F3FBFF' : '#ffffff'};
  color: ${props => props.$selected ? '#0280c6' : '#080808'};
  padding: 10px;
  border-top: 1px solid #c4c4c4;
  /* color: #080808; */
  font-size: 16px;
  word-wrap: break-word;
  cursor: pointer;
  &:last-child {
    border-bottom: 1px solid #c4c4c4;
  }
`;

export default ({
  selectedAssessmentName,
  onAssessementClicked,
  setHasTags,
  setHasAggregationGroups
}) => {
  const fetch = useFetch();

  const [isLoading, setIsLoading] = useState(true)
  const [assessmentNames, setAssessmentNames] = useState([]);

  const fetchAssessmentNames = async () => {
    try {
      setIsLoading(true);
      const response = await fetch(`assessment/list`, { method: 'GET' })
      const jsonData = await response.json();
      if (jsonData.error) {
        setAssessmentNames([])
      } else {
        setAssessmentNames(jsonData)
      }
      setIsLoading(false);
    } catch (e) {
      console.log(e)
      setAssessmentNames([])
      setIsLoading(false);
    }
  }

  useEffect(() => {
    fetchAssessmentNames()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    // When we initially load and no assessment name is selected..auto select the first item
    if (!selectedAssessmentName && assessmentNames[0] && assessmentNames[0].name) {
      onAssessementClicked(assessmentNames[0].name, assessmentNames[0])
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [assessmentNames, selectedAssessmentName])

  const doesAssessmentHaveTags = (name) => {
    const assessmentObj = assessmentNames.find(({ name: assessmentName}) => assessmentName === name);
    if (assessmentObj) {
      const { questions = [] } = assessmentObj;

      let hasTag = false;
      questions.forEach(({ tags }) => {
        if (tags && Array.isArray(tags) && tags.length > 0) {
          hasTag = true;
        }
      });

      return hasTag;
    } else {
      return true;
    }
  }

  const doesAssessmentHaveAggregationGroups = (name) => {
    const assessmentObj = assessmentNames.find(({ name: assessmentName}) => assessmentName === name);
    if (assessmentObj) {
      const { questions = [] } = assessmentObj;

      let hasAggregationGroup = false;
      questions.forEach(({ answerOptions }) => {
        if (answerOptions && Array.isArray(answerOptions)) {
          answerOptions.forEach(({ aggregationGroup }) => {
            if (aggregationGroup) {
              hasAggregationGroup = true;
            }
          });
        }
      });

      return hasAggregationGroup;
    } else {
      return false;
    }
  }

  return (

    <div style={{
      width: '300px',
      display: 'flex',
      flexDirection: 'column',
      // borderRight: '1px solid #c4c4c4',
      padding: '0px',
      height: 'calc(100vh - 297px)'
    }}>

        <div style={{
          color: '#565656',
          fontSize: '24px',
          fontWeight: 'bold',
          padding: '20px'
        }}>
          {'Assessment'}
        </div>

        <div style={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          overflow: 'auto'
        }}>
          {
            isLoading ?
              <div style={{
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                <LoadingIcon />
              </div>
              :
              assessmentNames
              .sort((a, b) => a.name.localeCompare(b.name))
              .map(assessmentObj => {
                const { name = '' } = assessmentObj;
                return (
                  <Item 
                    key={name} 
                    onClick={() => {
                      setHasTags(doesAssessmentHaveTags(name))
                      setHasAggregationGroups(doesAssessmentHaveAggregationGroups(name))
                      onAssessementClicked(name, assessmentObj)
                    }}
                    $selected={name === selectedAssessmentName}
                  >
                    {name}
                  </Item>
                )
              })
          }
        </div>

    </div>
  )
}